import React from "react";
import { Navigate } from "react-router-dom";

import { useProfile } from "../hooks";
import LoadingScreen from "../components/LoadingScreen";

const AuthProtected = (props: any) => {
  const { userProfile, loading } = useProfile();

  if (loading) {
    return <LoadingScreen />;
  }

  if (!userProfile) {
    return <Navigate to="/auth-login" />;
  }

  const authUser = localStorage.getItem("authUser");

  if (authUser) {
    try {
      const userData = JSON.parse(authUser);

      if (!userData || typeof userData !== "object") {
        localStorage.removeItem("authUser");
        return <Navigate to="/auth-login" />;
      }

      const companyId = userData.companyId || userData.companyID;

      if (
        !companyId ||
        companyId === 0 ||
        companyId === "0" ||
        companyId === ""
      ) {
        return <Navigate to="/onboarding" />;
      }
    } catch (e) {
      localStorage.removeItem("authUser");
      return <Navigate to="/auth-login" />;
    }
  }

  return <>{props.children}</>;
};

export { AuthProtected };
